const formatNumber = (number = 0) => {
  return number ? number.toLocaleString() : 0;
};

export {
  formatNumber
};